import React, { useState, useRef } from "react";
import {
  Button,
  Input,
  InputGroup,
  InputLeftElement,
  Stack,
  Textarea,
  Alert,
  AlertIcon,
  Box,
} from "@chakra-ui/react";
import { BsPerson, BsChat, BsSend } from "react-icons/bs";
import { MdEmail } from "react-icons/md";

const ContactForm = ({ buttonbg, butoncolor }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submissionStatus, setSubmissionStatus] = useState(null);
  const [file, setFile] = useState(null);
  const [isDragOver, setIsDragOver] = useState(false);
  const fileInputRef = useRef(null);
  const formRef = useRef(null);

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragOver(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDragOver(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragOver(false);
    const files = e.dataTransfer.files;
    if (files.length > 0) {
      setFile(files[0]);
    }
  };

  const handleFileChange = (e) => {
    if (e.target.files.length > 0) {
      setFile(e.target.files[0]);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmissionStatus(null);

    const formData = new FormData(e.target);
    formData.append("form-name", "contact");
    if (file) {
      formData.append("file", file);
    }

    try {
      const response = await fetch("/", {
        method: "POST",
        headers: { "X-Requested-With": "XMLHttpRequest" },
        body: formData,
      });

      if (response.ok) {
        setSubmissionStatus("success");
        formRef.current.reset();
        setFile(null);
      } else {
        setSubmissionStatus("error");
      }
    } catch (error) {
      console.error("Error:", error);
      setSubmissionStatus("error");
    }

    setIsSubmitting(false);
  };

  return (
    <form
      ref={formRef}
      onSubmit={handleSubmit}
      data-netlify="true"
      name="contact"
    >
      {/* Netlify Forms: honeypot field for spam detection */}
      <input type="hidden" name="bot-field" style={{ display: "none" }} />
      <Stack spacing={4}>
        <InputGroup>
          <InputLeftElement pointerEvents="none">
            <BsPerson color="#999999" />
          </InputLeftElement>
          <Input type="text" name="FNAME" placeholder="Name" bg="white" required />
        </InputGroup>

        <InputGroup>
          <InputLeftElement pointerEvents="none">
            <MdEmail color="#999999" />
          </InputLeftElement>
          <Input type="email" name="EMAIL" placeholder="Email" bg="white" required />
        </InputGroup>

        <Box
          border="2px dashed"
          borderColor={isDragOver ? "#DD9331" : "#999999"}
          borderRadius="md"
          p={4}
          textAlign="center"
          bg={isDragOver ? "gray.100" : "white"}
          cursor="pointer"
          onDrop={handleDrop}
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onClick={() => fileInputRef.current.click()}
        >
          {file
            ? `Selected: ${file.name}`
            : "Want to share a your project file? Drop it here or click to select"}
          <Input type="file" ref={fileInputRef} display="none" onChange={handleFileChange} />
        </Box>

        <InputGroup>
          <InputLeftElement pointerEvents="none">
            <BsChat color="#999999" />
          </InputLeftElement>
          <Textarea
            name="MESSAGE"
            placeholder="Message"
            pl="40px"
            minH="100px"
            bg="white"
            required
          />
        </InputGroup>

        <Button
          type="submit"
          bg={buttonbg}
          color={butoncolor}
          _hover={{ bg: "#A45826" }}
          rightIcon={<BsSend />}
          w="full"
          isDisabled={isSubmitting}
          isLoading={isSubmitting}
        >
          Send
        </Button>
      </Stack>
      {submissionStatus === "success" && (
        <Alert mt={4} rounded={"md"} status="success">
          <AlertIcon />
          Thank you for reaching out!.
        </Alert>
      )}
      {submissionStatus === "error" && (
        <Alert mt={4} rounded={"md"} status="error">
          <AlertIcon />
          There was an error sending your message. Please try again.
        </Alert>
      )}
    </form>
  );
};

export default ContactForm;